<ng-container>
  <nav>
    <ul class="d-flex flex-column">
      @for (page of pageARR; track page) {
        <li class="d-block" [class.active]="model === page.code" [class.no-pointer-events]="page.disabled" (click)="!page.disabled && modelChange.emit(page.code)">
          <div><span class="icon-container"><i class="im-icon im-icon-{{page.icon || 'arrow-right'}}"></i></span> {{page.name}} @if (page.notify) {
          <span class="ping"></span>
        }
        @if (page.showSubscriptionAmount) {
          (
          @if (!subscriptionAmountSpinner) {
            <span>{{subscriptionAmount}}</span>
          }
          @if (subscriptionAmountSpinner) {
            <app-inline-spinner></app-inline-spinner>
          }
          )
        }
      </div>
    </li>
  }
</ul>
</nav>
</ng-container>